import SetData from "@/vuex/SetData";
import Status from "@/vuex/Status";
import Config from "@/vuex/Config";
import CatchFetch from "@/assets/Cache/Fetch";
import Logger from "@/assets/Helper/Logger";
import Wishlist from "@/assets/Wishlist";

class DAOSet {

    getItemnumbers(setId, clear = true, setParameter = null) {
        Status.dispatch('setLoading', true).catch((error) => {
            Logger.error(error);
        });

        let setParaStr = "";

        if (typeof setParameter === 'object' && setParameter !== null) {
            const params = new URLSearchParams(setParameter);

            setParaStr = "?" + params.toString();
        }

        CatchFetch.cacheFirst(Config.getters.getApiHostWithLocalStr + '/v2/sets/itemnumbers/' + setId + '/' + setParaStr)
            .then(json => {
                if (clear === true) {
                    SetData.dispatch('clearItems', true)
                        .then(() => {
                            SetData.dispatch("setItemnumbersStart", json)
                            .then(() => {
                                this.addItems(json);
                            })
                            .catch((error) => {
                                Logger.error(error);
                            });
                        })
                        .catch((error) => {
                            Logger.error(error);
                        });
                } else {
                    this.addItems(json);
                }

                Status.dispatch('setLoading', false).catch((error) => {
                    Logger.error(error);
                });
            })
            .catch((error) => {
                Status.dispatch('setLoading', false).catch((error) => {
                    Logger.error(error);
                });
                Logger.error(error);
            });
    }

    addItems(items) {
        Wishlist.restoreDataFromWishlist(items).then(result => {
            if (result === false) {
                for (let i in items) {
                    if (Object.prototype.hasOwnProperty.call(items, i)) {
                        SetData.dispatch('addItem', items[i]).catch((error) => {
                            Logger.error(error);
                        });
                    }
                }
            } else {
                if (SetData.getters.getSet.items.length < 2) {
                    SetData.dispatch('setShowSetImage', false).catch((error) => {
                        Logger.error(error);
                    });
                }
            }
            Config.dispatch('setVisualMode', "show").then(() => {
                Config.dispatch('setCurrentVarType', Config.getters.getcurrentVarType).catch((error) => {
                    Logger.error(error);
                });
            });
        }).catch((error) => {
            Logger.error(error);
        });
    }
}

export default new DAOSet();
